import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { AccountRouterManager } from '../../controller/router-handler';
import { accountInfoModel } from '../../models/serviceResponse.model';
import { AccountModuleDisplayConfig, ACCOUNT_DISPLAY_CONFIG } from '../../module-config/module-config';
import { AccountActions } from '../../ngrx/account-action-types';
import { UpdateProfileService } from '../../services/update-profile.service';

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.css']
})
export class EditProfileComponent implements OnInit {

  accountInfo!: accountInfoModel;
  private accountRouter = new AccountRouterManager(this.router);

  isHideSendButton:boolean = false;

  name!:string;
  surname!:string;
  password!:string;

  constructor(
    private updateProfileService: UpdateProfileService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private router: Router,
    private store: Store,
    @Inject(ACCOUNT_DISPLAY_CONFIG) private accountRouterConfig: AccountModuleDisplayConfig,
  ) {
    this.accountRouter.setRouterConfig(accountRouterConfig.displayAreaConfig);

    if(this.router.getCurrentNavigation()?.extras.state && this.router.getCurrentNavigation()?.extras.state?.accountInfo){
      this.accountInfo = this.router.getCurrentNavigation()?.extras.state?.accountInfo;
    }else{
      this.accountRouter.toMyAccount();
    }
  }

  ngOnInit(): void {}

  saveChanges(){
    this.isHideSendButton = true;

    this.updateProfileService
    .updateNameAndSurname(this.name, this.surname, this.password)
    .pipe(
      finalize(() => {
        this.isHideSendButton = false;
      })
    )
    .subscribe(response =>{
      if(response === "OK"){
        this.toastr.success(this.translate.instant('ACCOUNT_CHANGEPROFILE_CHANGES_SUCCESSFUL'));
        this.store.dispatch(AccountActions.updateUserInformation({userInfo: {id: this.accountInfo.userId, changes: {userName: this.name + " " + this.surname}}}));
        this.accountRouter.toMyAccount();
      }else{
        this.toastr.error(this.translate.instant('ACCOUNT_CHANGEPROFILE_CHANGES_FAILED'))        
      }
    });
  }

}
